/* import __COLOCATED_TEMPLATE__ from './two-f-a-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();